import server from './index'

/**
 * 登录接口
 */
export function login({
  username,
  password,
  isRemember,
}) {
  return server.post('/sys/identification/login', {
    username,
    password,
    isRemember,
  })
}

// 二次认证接口
export function loginVerify({ code }) {
  return server.post('/sys/identification/verify', {
    code,
  });
}

/**
 * 注销登录接口
 */
export function logout() {
  return server.post('/sys/identification/logout')
}

/**
 * 获取当前用户登录信息
 */
export function getUserInfo() {
  return server.get('/sys/identification/userInfo')
}

//  上传文件
export function uploadFile(companyId, formData) {
  return server.post(`/files/${companyId}/app/upload/`, formData)
}

// 重置动态码绑定（系统）
export function sysResetTotp(code) {
  return server.get(`/sys/identification/totpUri?code=${code}`);
}
